module.exports = __webpack_public_path__ + "static/media/banner-momentos-bravecto-fim-mobile.63ca7e18.webp";